import { render, staticRenderFns } from "./setDialog.vue?vue&type=template&id=5ac60244&scoped=true&"
import script from "./setDialog.vue?vue&type=script&lang=js&"
export * from "./setDialog.vue?vue&type=script&lang=js&"
import style0 from "./setDialog.vue?vue&type=style&index=0&id=5ac60244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac60244",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ac60244')) {
      api.createRecord('5ac60244', component.options)
    } else {
      api.reload('5ac60244', component.options)
    }
    module.hot.accept("./setDialog.vue?vue&type=template&id=5ac60244&scoped=true&", function () {
      api.rerender('5ac60244', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/components/setDialog.vue"
export default component.exports